import { render, staticRenderFns } from "./Periodicals.vue?vue&type=template&id=03410bcc&scoped=true"
import script from "./Periodicals.vue?vue&type=script&lang=js"
export * from "./Periodicals.vue?vue&type=script&lang=js"
import style0 from "./Periodicals.vue?vue&type=style&index=0&id=03410bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03410bcc",
  null
  
)

export default component.exports